export enum FocusServerErrorCode {
    FocusError = "FocusError",
    HttpError = "HttpError",
    NotWork = "NotWork",
    NotInn = "NotInn",
    NoInnError = "NoInnError",
}

export interface GetByInnResponseInfo {
    error: undefined | string;
    errorCode: undefined | FocusServerErrorCode;
    value: undefined | string;
}

export interface GetByInnResponse {
    [inn: string]: GetByInnResponseInfo;
}
